import { ConnectData, SecondaryOption } from "../../../types/admin";
import {Col, Table} from "react-bootstrap";
import { ArrowRight } from 'react-bootstrap-icons';
import {ADMIN_LANG} from "../../../settings";

const findOption2Label = (options: SecondaryOption[], correct_connection_id: string): string => {
    const option = options.find(opt => opt.option_id === correct_connection_id);
    return option ? option.label : "";
};

// Memoized row component for displaying connections
const ConnectTableRow = ({ option1Label, option2Label, connectionAmount }: { option1Label: string, option2Label: string, connectionAmount: number }) => {
    return (
        <tr>
            <td>{option1Label}</td>
            <td className="text-center"><ArrowRight /></td>
            <td>{option2Label}</td>
            <td className="text-center text-success">{connectionAmount}</td>
        </tr>
    );
};

const ConnectTable = ({ optionsData }: { optionsData: ConnectData }) => {
    const { options1, options2, connections } = optionsData;

    // Helper function to find the connection amount
    const findConnectionAmount = (option1_id: string, option2_id: string): number => {
        return connections.reduce((count, connection) => {
            if (connection.option1_id === option1_id && connection.option2_id === option2_id && connection.amount > 0) {
                return count + connection.amount;
            }
            return count;
        }, 0);
    };

    return (
        <Col xs={12} md={6}>
        <div className='admin-card'>
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th colSpan={3}>{ADMIN_LANG.correct_pairs}</th>
                        <th className="text-center">{ADMIN_LANG.correct_connections}</th> {/* New header for connection amount */}
                    </tr>
                </thead>
                <tbody>
                    {options1.map((option1) => {
                        const option2Label = findOption2Label(options2, option1.correct_connection_id);
                        const connectionAmount = findConnectionAmount(option1.option_id, option1.correct_connection_id);
                        return (
                            <ConnectTableRow
                                key={option1.option_id}
                                option1Label={option1.label}
                                option2Label={option2Label}
                                connectionAmount={connectionAmount}  // Pass the calculated amount
                            />
                        );
                    })}
                </tbody>
            </Table>
        </div>
        </Col>
    );
};
export default ConnectTable;